import { MyCanoncpsccComponent } from "./MyCanoncpsccComponent";

export function MyCanoncpsccScreen() {
  return (
    <>
      <MyCanoncpsccComponent />
    </>
  );
}
